import { merge, Observable } from 'rxjs'
import trackActions from '../../../actions/tracks'
import { trackStatus } from '@bt-react/constants'
import isScreenshareTrack from '../../../../lib/isScreenshareTrack'
import roomActions from '../../../actions/room'
import { debug } from '@bt-react/libs/Logger'
import throttle from 'lodash/throttle'
import { addEntry } from '../../../../lib/audit'

export default function (room, state) {

  return new Observable(observer => {
    merge(
      room.on('participantConnected', ({ sid = '', identity = '' }) => { 
        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          addEntry('PresenterService', 'ParticipantConnected', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} connected - user_id:${identity} sid:${sid}`, 'info', identity)

        }

        return observer.next(roomActions.participantConnected(sid, identity, true))
      }),
      room.on('participantDisconnected', ({ sid = '', identity = '' }) => {
        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          addEntry('PresenterService', 'ParticipantDisconnected', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} disconnected - user_id:${identity} sid:${sid}`, 'info', identity)

        }
        return observer.next(roomActions.participantDisconnected(sid, identity))
      }),
      room.on('participantReconnected', ({ sid = '', identity = '' }) => {
        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          addEntry('PresenterService', 'ParticipantReconnected', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} reconnected - user_id:${identity} sid:${sid}`, 'info', identity)

        }
      }),
      room.on('participantReconnecting', ({ sid = '', identity = '' }) => {
        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          addEntry('PresenterService', 'ParticipantReconnecting', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} reconnecting - user_id:${identity} sid:${sid}`, 'info', identity)

        }
      }),
      room.on('reconnecting', (error) => {
        const { firstName, lastName, externalIdV2} = state.value.user.data
        addEntry('PresenterService', 'ReconnectingLocal', `${firstName} ${lastName} reconnecting - user_id:${externalIdV2} - ${error}`, 'info', externalIdV2)
        return observer.next(roomActions.participantReconnecting(error))
      }),
      room.on('reconnected', () => {
        const { firstName, lastName, externalIdV2} = state.value.user.data
        addEntry('PresenterService', 'ReconnectedLocal', `${firstName} ${lastName} reconnected - user_id:${externalIdV2}`, 'info', externalIdV2)
        return observer.next(roomActions.participantReconnected(room))
      }),
      room.on('disconnected', (room, error) => {
        const { firstName, lastName, externalIdV2} = state.value.user.data
        addEntry('PresenterService', 'DisconnectedLocal', `${firstName} ${lastName} disconnected - user_id:${externalIdV2} - ${error}`, 'info', externalIdV2)
      }),
      room.on('trackSubscribed', (track, publication, presenter) => {

        const { identity, sid } = presenter
        const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === presenter.identity) || { firstName: 'null', lastName: 'null'}

        debug(`${publication.kind} track subscribed`)
        if (publication.kind === 'audio') {
          addEntry('PresenterService', 'ParticipantAudioTrackSubscribed', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} - user_id:${identity} sid:${sid} trackSid:${track.sid}`, 'info', identity)
          observer.next(trackActions.setEnabledAudioTrackEntry(publication.trackSid))
        }

        if (publication.kind === 'video') {
          addEntry('PresenterService', 'ParticipantVideoTrackSubscribed', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} - user_id:${identity} sid:${sid} trackSid:${track.sid}`, 'info', identity)
          observer.next(trackActions.setEnabledVideoTrackEntry(publication.trackSid))
        }

        observer.next(trackActions.setTrackStatus(presenter.sid, track.sid, trackStatus.STAGED))
        if (isScreenshareTrack(publication)) {

          observer.next(trackActions.setScreenshare(presenter.sid))

        }

      }),
      room.on('trackMessage', (data, track, { identity, sid }) => {
        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          addEntry('PresenterService', 'ParticipantTrackMessage', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} - user_id:${identity} sid:${sid} data:${data} trackSid:${track.sid}`, 'info', identity)

        }
      }),
      room.on('trackPublished', (publication, { identity, sid }) => {

        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          if (publication.kind === 'audio') {
            addEntry('PresenterService', 'ParticipantAudioTrackPublished', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} audio published - user_id:${identity} sid:${sid}`, 'info', identity)
          }

          if (publication.kind === 'video') {
            addEntry('PresenterService', 'ParticipantVideoTrackPublished', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} video published - user_id:${identity} sid:${sid}`, 'info', identity)
          }
        }

      }),
      room.on('trackStarted', (track, { identity, sid }) => {

        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          addEntry('PresenterService', 'ParticipantTrackStarted', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} track started - trackSid:${track.sid} - user_id:${identity} sid:${sid}`, 'info', identity)
        }

      }),
      room.on('trackUnsubscribed', (track, publication, { identity, sid }) => {
        
        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          if (publication.kind === 'audio') {
            addEntry('PresenterService', 'ParticipantAudioTrackUnsubscribed', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} audio unsubscribed - user_id:${identity} sid:${sid}`, 'info', identity)
          }

          if (publication.kind === 'video') {
            addEntry('PresenterService', 'ParticipantVideoTrackUnsubscribed', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} video unsubscribed - user_id:${identity} sid:${sid}`, 'info', identity)
          }
        }

        if (track.sid && sid) observer.next(trackActions.unattachedTrack(sid, track.sid))
        if (publication.kind === 'audio') observer.next(trackActions.removeEnabledAudioTrackEntry(publication.trackSid))
        if (publication.kind === 'video') observer.next(trackActions.removeEnabledVideoTrackEntry(publication.trackSid))

      }),
      room.on('trackDisabled', (publication, { identity, sid }) => {

        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          if (publication.kind === 'audio') {
            addEntry('PresenterService', 'ParticipantAudioTrackDisabled', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} audio disabled - user_id:${identity} sid:${sid}`, 'info', identity)
          }

          if (publication.kind === 'video') {
            addEntry('PresenterService', 'ParticipantVideoTrackDisabled', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} video disabled - user_id:${identity} sid:${sid}`, 'info', identity)
          }
        }

        if (publication.kind === 'audio') {

          observer.next(roomActions.participantMuted(identity))
          observer.next(trackActions.removeEnabledAudioTrackEntry(publication.trackSid))

        }
        if (publication.kind === 'video') {

          observer.next(roomActions.participantCamHidden(identity))
          observer.next(trackActions.removeEnabledVideoTrackEntry(publication.trackSid))

        }

      }),
      room.on('trackSwitchedOff', (track, publication, { identity, sid }) => {
        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          if (publication.kind === 'audio') {
            addEntry('PresenterService', 'ParticipantAudioTrackSwitchedOff', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} audio switched off - user_id:${identity} sid:${sid}`, 'info', identity)
          }

          if (publication.kind === 'video') {
            addEntry('PresenterService', 'ParticipantVideoTrackSwitchedOff', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} video switched off - user_id:${identity} sid:${sid}`, 'info', identity)
          }
        }
      }),
      room.on('trackSwitchedOn', (track, publication, { identity, sid }) => {
        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          if (publication.kind === 'audio') {
            addEntry('PresenterService', 'ParticipantAudioTrackSwitchedOn', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} audio switched on - user_id:${identity} sid:${sid}`, 'info', identity)
          }

          if (publication.kind === 'video') {
            addEntry('PresenterService', 'ParticipantVideoTrackSwitchedOn', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} video switched on - user_id:${identity} sid:${sid}`, 'info', identity)
          }
        }
      }),
      room.on('trackUnpublished', (publication, { identity, sid }) => {
        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          if (publication.kind === 'audio') {
            addEntry('PresenterService', 'ParticipantAudioTrackUnpublished', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} audio unpublished - user_id:${identity} sid:${sid}`, 'info', identity)
          }

          if (publication.kind === 'video') {
            addEntry('PresenterService', 'ParticipantVideoTrackUnpublished', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} video unpublished - user_id:${identity} sid:${sid}`, 'info', identity)
          }
        }
      }),
      room.on('trackSubscriptionFailed', (error, publication, { identity, sid }) => {
        if (state.value.config.bridgeName !== "") {
          const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === identity) || { firstName: 'null', lastName: 'null'}
          if (publication.kind === 'audio') {
            addEntry('PresenterService', 'ParticipantAudioTrackSubscriptionFailed', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} audio subscription failed (${error.toString()})- user_id:${identity} sid:${sid}`, 'info', identity)
          }

          if (publication.kind === 'video') {
            addEntry('PresenterService', 'ParticipantVideoTrackSubscriptionFailed', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} video subscription failed (${error.toString()})- user_id:${identity} sid:${sid}`, 'info', identity)
          }

        }
      }),
      room.on('trackEnabled', (publication, participant) => {

        const { firstName, lastName } = state.value.room.participantInformation.find(({id}) => id === participant.identity) || { firstName: 'null', lastName: 'null'}

        debug(`${publication.kind} track enabled`)
        if (publication.kind === 'audio') {

          if (state.value.config.bridgeName !== "") {
              addEntry('PresenterService', 'ParticipantAudioTrackEnabled', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} audio enabled - user_id:${participant.identity} sid:${participant.sid}`, 'info', participant.identity)
          }

          observer.next(roomActions.participantUnmuted(participant.identity))

          // trackEnabled is triggered before trackSubscribed initially, so check it's subscribed before adding
          // otherwise let trackSubscribed add the sid
          if (publication.isSubscribed) {

            observer.next(trackActions.setEnabledAudioTrackEntry(publication.trackSid))

          }

        }
        if (publication.kind === 'video') {

          if (state.value.config.bridgeName !== "") {
            addEntry('PresenterService', 'ParticipantVideoTrackEnabled', `bridge: ${state.value.config.bridgeName} - ${firstName} ${lastName} video enabled - user_id:${participant.identity} sid:${participant.sid}`, 'info', participant.identity)
          }

          if (publication.isSubscribed) {

            observer.next(trackActions.setEnabledVideoTrackEntry(publication.trackSid))

          }
          if (!isScreenshareTrack(publication)) observer.next(roomActions.participantCamVisible(participant.identity))

        }

      }),
      room.on('dominantSpeakerChanged', throttle(participant => observer.next(roomActions.setDominantSpeaker(participant)), 1500)),
    )
  })

}
